import React, { useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { User } from '../types/api';

const parseUser = (encodedUser: string | null): User | null => {
  if (!encodedUser) return null;
  try {
    const base64 = encodedUser.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as User;
  } catch {
    return null;
  }
};

export const AuthCallbackPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeLogin } = useAuth();
  const [failed, setFailed] = useState(false);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    const token = params.get('token');
    const user = parseUser(params.get('user'));
    if (!token || !user) {
      setFailed(true);
      return;
    }

    completeLogin(token, user);
    navigate(params.get('redirect') || '/', { replace: true });
  }, [completeLogin, navigate, params]);

  if (failed) {
    return <Navigate to="/login" replace />;
  }

  return <main className="mx-auto max-w-4xl px-4 py-10 text-stone-300">Completing Login...</main>;
};
